module.exports = __webpack_public_path__ + "img/loginTips.d67e4e8a.png";